import 'chosen-js'
import '../css/chosen.css'

$(function() {
  $('.chzn-select').chosen({ width: '100%' })
  $('.chzn-select-deselectable').chosen({ allow_single_deselect: true, width: '100%' })
})
